var map = {
	"./footer-links.de-CH.json": 977,
	"./footer-links.de-DE.json": 978,
	"./footer-links.en-CA.json": 979,
	"./footer-links.en-GB.json": 980,
	"./footer-links.en-IN.json": 981,
	"./footer-links.en-ME.json": 982,
	"./footer-links.en-US.json": 983,
	"./footer-links.es-EM.json": 984,
	"./footer-links.es-ES.json": 985,
	"./footer-links.fr-BE.json": 986,
	"./footer-links.fr-CA.json": 987,
	"./footer-links.fr-CH.json": 988,
	"./footer-links.nl-BE.json": 989,
	"./footer-links.nl-NL.json": 990,
	"./footer-links.pl-PL.json": 991,
	"./footer-links.pt-BR.json": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 976;